import React, { Suspense } from 'react';
import { Flex, Spinner } from '@optiaxiom/react';

export type MarkdownTextProps = {
  text: string;
};

const FallbackMarkdownText: React.FC<MarkdownTextProps> = ({ text }) => (
  <div>Chat component failed to load: {text}</div>
);

// Create a lazy-loaded component using React.lazy()
const LazyMarkdownText = React.lazy<React.ComponentType<MarkdownTextProps>>(() =>
  // @ts-expect-error - External module import
  import('OpalChat/MarkdownText')
    .then(m => ({
      default: m.default,
    }))
    .catch(error => {
      console.error('Failed to load OpalChat MarkdownText component:', error);
      return {
        default: FallbackMarkdownText,
      };
    })
);

// Simple loader component for markdown text
const MarkdownLoader: React.FC = () => (
  <Flex justifyContent="center" alignItems="center" p="8">
    <Spinner size="sm" />
  </Flex>
);

// Export the lazy component separately in case you want to use custom Suspense
export { LazyMarkdownText };

// Main component that wraps the lazy component with Suspense
export const MarkdownText: React.FC<MarkdownTextProps> = props => {
  return (
    <Suspense fallback={<MarkdownLoader />}>
      <LazyMarkdownText {...props} />
    </Suspense>
  );
};
